import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormControl, Validators } from '@angular/forms';

import { CommonService } from 'src/app/services/common.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { FieldConfig } from '../field-interface';
import { TaxService } from 'src/app/services/tax.service';
import { SupplierService } from 'src/app/services/supplier.service';
import { Constant } from 'src/app/constant/constant';
import { TIMEZONE_ZONES, TimezoneOption } from 'src/app/shared/utils/timezone-zones.constant';
import { SizechartService } from 'src/app/services/sizechart.service';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { UsersService } from 'src/app/services/users.service';
import { CmsPageService } from 'src/app/services/cms-page.service';
import { LecturerService } from 'src/app/services/lecturer.service';
import { DoctorService } from 'src/app/services/doctor-service.service';
import { CatalogPriceRulesService } from 'src/app/services/catalog-price-rules.service';
import { ProductService } from 'src/app/services/product.service';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import { DynamicFormGroupService } from 'src/app/services/dynamic-form-group.service';
import { PriorityService } from 'src/app/services/priority.service';
import { TrackerService } from 'src/app/services/tracker.service';
import { Router, NavigationEnd } from '@angular/router';
import { StatusService } from 'src/app/services/status.service';
import { DealStatusService } from 'src/app/services/deal-status.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { DealsStageService } from 'src/app/services/deals-stage.service';
import { DistributorService } from 'src/app/services/distributor.service';
import { CatalogProductPincodePricingGroupService } from 'src/app/services/catalog-product-pincode-pricing-group.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { IndustryTypeService } from 'src/app/services/industry-type.service';
import { BussinessTypeService } from 'src/app/services/bussiness-type.service';
import { MetalRatesService } from 'src/app/services/metal-rates.service';
import { MatSelect } from '@angular/material/select';
import { TaskStatusService } from 'src/app/services/task-status.service';
import { SequencesService } from 'src/app/services/sequences.service';
import { DealClosingReasonService } from 'src/app/services/deal-closing-reason.service';
import { CountryStateCityService } from 'src/app/services/country-state-city.service';
import { ProjectStageService } from 'src/app/services/project-stage.service';
import { CategoriesService } from 'src/app/services/categories.service';

@Component({
  selector: 'calsoft-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit, OnChanges, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  field: FieldConfig['eavAttribute'];

  eavEntityAttribute: FieldConfig[] = [];


  group: UntypedFormGroup;
  Option: any;
  fieldTypeList: any;

  value: any;

  newType: any = 1;
  filteredcountryTypeList: any;
  countryTypeList: any;
  countryControl: UntypedFormControl = new UntypedFormControl();
  countryFilterControl: UntypedFormControl = new UntypedFormControl();

  filteredTaxClassList: any;
  taxClassTypeList: any;
  taxclassControl: UntypedFormControl = new UntypedFormControl();
  taxclassFilterControl: UntypedFormControl = new UntypedFormControl();

  filteredPicodeBasedList: any;
  pincodeBasedTypeList: any;
  pincodeBasedControl: UntypedFormControl = new UntypedFormControl();
  pincodeBasedFilterControl: UntypedFormControl = new UntypedFormControl();

  supDisabled: boolean = false;
  protected _onDestroy = new Subject<void>();
  searchTermValue: string;
  firstFormGroup: UntypedFormGroup
  categoryId: any;
  sizeChart: Object;
  display: boolean;
  spinner: boolean;
  dealsProduct: boolean;
  filteredProductTypeList: any;
  metalsType: any = [];
  taskStatusEnable: boolean = false;
  propertyStatus: boolean = false;
  productStatus: boolean = false;
  reasonForLostList: any;
  private _showReasonForLoss: boolean = false;
  get showReasonForLoss(): boolean {
    return this._showReasonForLoss;
  }
  set showReasonForLoss(value: boolean) {
    this._showReasonForLoss = value;
    const control = this.group?.get('ReasonForLoss');
    if (control) {
      if (value) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    }
  }

  // Country, State, City properties for location API
  locationCountries: any[] = [];
  locationStates: any[] = [];
  locationCities: any[] = [];

  filteredLocationCountries: any[] = [];
  filteredLocationStates: any[] = [];
  filteredLocationCities: any[] = [];

  selectedCountryId: any = null;
  selectedStateId: any = null;
  selectedCityId: any = null;

  countrySearchControl = new FormControl();
  stateSearchControl = new FormControl();
  citySearchControl = new FormControl();

  constructor(
    private ecryptService: EcryptServiceService,
    private commonService: CommonService,
    private taxService: TaxService,
    private supplierService: SupplierService,
    private sizechartService: SizechartService,
    private leadSourceService: LeadSourceService,
    private leadStatusService: LeadStatusService,
    private dealClosingReasonService: DealClosingReasonService,
    private usersService: UsersService,
    private cmsPageService: CmsPageService,
    private lecturerService: LecturerService,
    private doctorService: DoctorService,
    private tagesStatusService: TagesStatusService,
    private catalogPriceRulesService: CatalogPriceRulesService,
    public productService: ProductService,
    private dynamicFormLabelService: DynamicFormLabelService,
    private dynamicFormGroupService: DynamicFormGroupService,
    private priorityService: PriorityService,
    private trackerService: TrackerService,
    private router: Router,
    private statusService: StatusService,
    private dealStatusService: DealStatusService,
    private dealsStageService: DealsStageService,
    private distributorService: DistributorService,
    private projectsService: ProjectsService,
    private catalogProductPincodePricingGroupService: CatalogProductPincodePricingGroupService,
    private industryTypeService: IndustryTypeService,
    private bussinessTypeService: BussinessTypeService,
    private metalRateService: MetalRatesService,
    private taskStatusService: TaskStatusService,
    private sequencesService: SequencesService,
    private countryStateCityService: CountryStateCityService,
    private cdr: ChangeDetectorRef,
    private projectStageService: ProjectStageService,
    private categoriesService: CategoriesService,
  ) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }
  productInit: any = false;
  technicianId: any = 0;


  ngOnInit() {

    if (this.field.frontendLabel == 'Product') {
      let value = this.group.value?.Category || this.group.value?.categoryId || this.group.value?.CategoryName;

      if (value != undefined && value != null && value !== '' && (typeof value === 'number' ? value > 0 : value.length > 0)) {
        this.setCategoryNew(value);
        this.productInit = true;
      } else {
        this.getProduct('');
      }

      this.group.get('Category')?.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(val => {
          if (val != null && val !== '') {
            this.setCategoryNew(val);
          } else {
            this.getProduct('');
          }
        });
    }


    if (this.field.frontendLabel == 'Country' || this.field.frontendLabel == 'State' || this.field.frontendLabel == 'City') {
      this.loadLocationCountries();
      this.onLocationCountrySearch();
      this.onLocationStateSearch();
      this.onLocationCitySearch();

      setTimeout(() => {
        this.loadExistingLocationData();
      }, 500);
    }

    this.countrYFilter();
    this.getAllCountry();
    this.getAllField();
    this.fielDFilter();
    this.getAllTaxclass();

    this.taxclassYFilter();

    this.PriorityYFilter();
    this.getAllPriority();
    this.getAllPicodeBased();
    this.PicodeBasedYFilter();

    if (this.isTagField(this.field)) {
      this.getAllTags();
      this.TagsYFilter();
    }
    if (this.router.url.includes('/product') && this.field.frontendLabel == 'Status') {
      this.productStatus = true;
      this.Option = [
        { regionId: 1, defaultName: 'Enabled' },
        { regionId: 0, defaultName: 'Disabled' },
      ]
    }
    else if (this.router.url.includes('/property') && this.field.frontendLabel == 'Status') {
      this.propertyStatus = true;
      this.Option = [
        { regionId: 1, defaultName: 'Active' },
        { regionId: 0, defaultName: 'In-Active' },
      ]
    }
    else if (this.field.frontendLabel == 'Visibility') {
      this.Option = [
        { regionId: 1, defaultName: 'not visible individually' },
        { regionId: 2, defaultName: 'catalog' },
        { regionId: 3, defaultName: 'search' },
        { regionId: 4, defaultName: 'catalog,search' }
      ]
    }
    else if (this.router.url.includes('/lead') && this.field.frontendLabel == 'Priority') {
      this.Option = [
        { regionId: 0, defaultName: 'High' },
        { regionId: 1, defaultName: 'Medium' },
        { regionId: 2, defaultName: 'Low' },
      ]
    }
    else if (this.field.frontendLabel == 'Time Zone') {

      this.filterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterStatus();
        });

      this.filteredStatus = this.zone.slice();

    }
    else if (this.field.frontendLabel == 'Country of Manufacture') {
      this.commonService.getCountryList()
        .pipe(take(1))
        .subscribe(
          res => {
            this.countryTypeList = res;
            this.filteredcountryTypeList = this.countryTypeList;
          },
          error => {
          }
        )
    }
    else if (this.field.frontendLabel == 'sizeChart') {
      this.field.eavAttributeOption = [];
      this.sizechartService.getAllSizeChartDropDown()
        .pipe(take(1))
        .subscribe(
          res => {
            this.sizeChart = res;
            // this.filteredcountryTypeList = this.countryTypeList;
          },
          error => {
          }
        )
    }
    else if (this.field.frontendLabel == 'Metal Type') {
      this.field.eavAttributeOption = [];
      this.metalRateService.getAllMetalRatesDropDown()
        .pipe(take(1))
        .subscribe(
          res => {
            this.metalsType = res;

            let value = this.group.value.MetalType;

            let index = this.metalsType.findIndex(
              x => x.metalRateId == value
            );

            if (index == -1) {
              this.group.get('MetalType').setValue(0);
              value = 0
            }

            if (value > 0) {



            } else {
              this.group.get('MetalType').setValue(this.metalsType[0].metalRateId);

              this.updatePrice(this.metalsType[0].ratePerGram);

            }

            // this.filteredcountryTypeList = this.countryTypeList;
          },
          error => {
          }
        )
    }
    else if (this.field.frontendLabel == 'Lead Source') {
      this.LeadSourceYFilter();
      this.getLeadSourceList();
      this.field.eavAttributeOption = [];
      this.leadSourceService.getAllLeadSourceDropDown()
        .pipe(take(1))
        .subscribe(
          res => {
            this.leadSourceList = res;
            this.leadSourceTypeList = res;
            this.filteredleadSourceTypeList = this.leadSourceTypeList;
          },
          error => {
          }
        )
    }
    else if (this.field.frontendLabel == 'Sequence') {

      this.getSequncesDropDownList();
      this.typeSequncesYFilter();

    }
    else if (this.field.frontendLabel == 'Products') {


      this.productNewYFilter();
      this.getproductNewList();
      this.field.eavAttributeOption = [];
      this.productService.getAllActiveProduct()
        .pipe(take(1))
        .subscribe(


          res => {
            this.productNewList = res;
            this.productNewTypeList = res;
            this.filteredproductNewTypeList = this.productNewList;
          },
          error => {
          }
        )
    }
    else if (this.field.frontendLabel == 'Lead Status') {
      this.field.eavAttributeOption = [];
      this.leadStatusService.getAllLeadStatusDropDown(0)
        .pipe(take(1))
        .subscribe(
          res => {

            let selectedValue = this.group.value.LeadStatus;



            this.leadStatusList = res;
            this.leadStatusTypeList = res;

            if (selectedValue != undefined) {
              if (selectedValue > 0) {
                let index = this.leadStatusList.findIndex(x => x.statusId == selectedValue);

                if (index > -1) {
                  this.getcreateDynamicForm(this.leadStatusList[index].dynamicFormGroupId);

                }
              }
            }

            this.filteredleadStatusTypeList = this.leadStatusTypeList;
          },
          error => {
          }
        )
      this.LeadStatusYFilter();
      this.getLeadStatusList();
    } else if (this.router.url.includes('/deals') && this.field.frontendLabel == 'Deal Name') {

      this.dealsProduct = true;
      this.field.eavAttributeOption = [];

    }
    else if (this.field.frontendLabel == 'Stage') {
      this.field.eavAttributeOption = [];
      this.dealsStageService.getAllDealsStagesDropDownNew(4)
        .pipe(take(1))
        .subscribe(
          res => {

            let selectedValue = this.group.value.Stage;

            this.leadStatusList = res;
            this.leadStatusTypeList = res;
            this.filteredleadStatusTypeList = this.leadStatusTypeList;

            setTimeout(() => {
              const initialValue = this.group.get(this.field.attributeCode)?.value;
              if (initialValue) {
                this.checkStageValueForLoss(initialValue);
              }
            }, 100);

            if (selectedValue != undefined) {
              if (selectedValue > 0) {
                let index = this.leadStatusList.findIndex(x => x.statusId == selectedValue);

                if (index > -1) {
                  this.getcreateDynamicForm(this.leadStatusList[index].dynamicFormGroupId);
                  this.cdr.detectChanges();
                }
              }
            }

          },
          error => {
          }
        )
      this.LeadStatusYFilter();
      this.getLeadStatusList();

      this.dealClosingReasonService.getAllLeadStatusDropDown(9)
        .pipe(take(1))
        .subscribe(
          res => {

            let selectedValue = this.group.value.LeadStatus;



            this.dealsCloseReasonList = res;


            if (selectedValue != undefined) {
              if (selectedValue > 0) {
                let index = this.dealsCloseReasonList.findIndex(x => x.statusId == selectedValue);

                if (index > -1) {
                  this.getcreateDynamicForm(this.dealsCloseReasonList[index].dynamicFormGroupId);

                }
              }
            }

            this.filteredDealsCloseReasonTypeList = this.dealsCloseReasonList;
          },
          error => {
          }
        )
      this.DealsCloseReasonYFilter();
      this.getDealsCloseReasonList();

    }

    else if (this.field.frontendLabel == 'Deals Status') {
      this.field.eavAttributeOption = [];
      this.dealStatusService.getAllDealStatusDropDown(1)
        .pipe(take(1))
        .subscribe(
          res => {

            this.leadStatusList = res;
            this.leadStatusTypeList = res;
            this.filteredleadStatusTypeList = this.leadStatusTypeList;

          },
          error => {
          }
        )
      this.LeadStatusYFilter();
      this.getLeadStatusList();

    }

    else if (this.field.frontendLabel == 'Project Stage') {
      this.field.eavAttributeOption = [];
      this.projectStageService.getAllProjectStagesDropDown(12)
        .pipe(take(1))
        .subscribe(
          res => {

            this.projectStageList = res;
            this.projectStageTypeList = res;
            this.filteredprojectStageTypeList = this.projectStageTypeList;

          },
          error => {
          }
        )
      this.ProjectStageYFilter();
      this.getProjectStageList();

    }

    else if (this.router.url.includes('/lead') && this.field.frontendLabel == 'Status') {
      this.field.eavAttributeOption = [];
      this.statusService.getAllLeadStatusDropDown(2)
        .pipe(take(1))
        .subscribe(
          res => {

            this.leadStatusList = res;
            this.leadStatusTypeList = res;
            this.filteredleadStatusTypeList = this.leadStatusTypeList;

          },
          error => {
          }
        )
      this.LeadStatusYFilter();
      this.getLeadStatusList();

    }

    else if (this.router.url.includes('/task') && this.field.frontendLabel == 'Status') {
      this.field.eavAttributeOption = [];
      this.taskStatusEnable = true;
      this.taskStatusService.getAlltaskStatusDropDown(8)
        .pipe(take(1))
        .subscribe(
          res => {

            this.leadStatusList = res;
            this.leadStatusTypeList = res;
            this.filteredleadStatusTypeList = this.leadStatusTypeList;

          },
          error => {
          }
        )
      this.LeadStatusYFilter();
      this.getLeadStatusList();

    }

    else if (this.field.frontendLabel == 'Layout') {
      this.getCmsList();
      this.CmsYFilter();
      this.field.eavAttributeOption = [];
      this.cmsPageService.getAllCmsDropDown()
        .pipe(take(1))
        .subscribe(
          res => {
            this.cmsList = res;
            this.cmsTypeList = res;
            this.filteredCmsTypeList = this.cmsTypeList;
          },
          error => {
          }
        )
    }
    else if (this.field.frontendLabel == 'Owner') {
      this.field.eavAttributeOption = [];

      let val: any = localStorage.getItem(Constant.SU);
      let userType: any = localStorage.getItem(Constant.Sup);

      if (val > 0 || userType === 'Sales User') {

        this.technicianId = val;
        this.display = true;
      } else {


        this.usersService.getAllUserStatusDropDown()
          .pipe(take(1))
          .subscribe(
            res => {



              this.userList = res;
              this.userTypeList = res;
              this.filtereduserTypeList = this.userTypeList;

              // if (this.router.url.includes('/deals/')) {
              //   if (this.filtereduserTypeList.length > 0 && userEmail) {
              //     const matchedUser = this.filtereduserTypeList.find(u => u.email === userEmail);
              //     if (matchedUser) {
              //       this.group.get(this.field.attributeCode)?.setValue(matchedUser.email);
              //     } else {
              //       this.group.get(this.field.attributeCode)?.setValue(this.filtereduserTypeList[0].email);
              //     }
              //   }

              // }


            },
            error => {
            }
          )
        this.display = false;

      }

      this.getOwnerList();
      this.LeadOwnerYFilter();

    }
    else if (this.field.frontendLabel == 'Country') {
      this.commonService.getCountryList()
        .pipe(take(1))
        .subscribe(
          res => {
            this.countryTypeList = res;
            this.filteredcountryTypeList = this.countryTypeList;
          },
          error => {
          }
        )
    }
    else if (this.field.frontendLabel == 'Tax Class') {
      this.taxService.getTaxClassProduct()
        .pipe(take(1))
        .subscribe(
          res => {
            this.taxClassTypeList = res;
            this.filteredTaxClassList = this.taxClassTypeList;
          },
          error => {
          }
        )
    }
    else if (this.field.frontendLabel == 'Pincode Based') {
      this.catalogProductPincodePricingGroupService.getAllCatalogProductPincodePricingGroupDropDown()
        .pipe(take(1))
        .subscribe(
          res => {
            this.pincodeBasedTypeList = res;
            this.filteredPicodeBasedList = this.pincodeBasedTypeList;
          },
          error => {
          }
        )

    }

    else if (this.field.frontendLabel == 'Lecture') {
      this.field.eavAttributeOption = [];
      this.lecturerService.getAllLecturerDropDown(2)
        .pipe(take(1))
        .subscribe(
          data => {
            this.lectureList = data;
            this.lectureTypeList = data;
            this.filteredlectureTypeList = this.lectureTypeList;
          },
          error => {
          }
        )
      this.LectureYFilter();
      this.getAllLecture();


    }
    else if (this.field.frontendLabel == 'Distributor') {
      this.distributorService.getAllDistributorDropDown()
        .pipe(take(1))
        .subscribe(
          data => {
            this.distributorTypeList = data;
            this.filteredDistributorTypeList = this.distributorTypeList;
          },
          error => {
          }
        )
      this.DistributorYFilter();
      this.getdistributorList();


    }

    else if (this.field.frontendLabel == 'Doctor') {
      this.field.eavAttributeOption = [];
      this.doctorService.getAllDoctorDropDown(3)
        .pipe(take(1))
        .subscribe(
          data => {
            this.doctorList = data;
            this.doctorTypeList = data;
            this.filteredDoctorTypeList = this.doctorTypeList;
          },
          error => {
          }
        )
      this.DoctorYFilter();
      this.getAllDoctor();


    }

    else if (this.field.frontendLabel == 'Priority') {
      this.field.eavAttributeOption = [];
      this.priorityService.getAllPriorityDropDown()
        .pipe(take(1))
        .subscribe(
          data => {
            this.priorityList = data;
            this.priorityTypeList = data;

            this.filteredPriorityTypeList = this.priorityTypeList;
          },
          error => {
          }
        )
      this.PriorityYFilter();
      this.getAllPriority();


    }

    else if (this.field.frontendLabel == 'Tracker') {
      this.field.eavAttributeOption = [];
      this.trackerService.getAllTrackerDropDown()
        .pipe(take(1))
        .subscribe(
          data => {
            this.trackerList = data;
            this.trackerTypeList = data;
            this.filteredTrackerTypeList = this.trackerTypeList;
          },
          error => {
          }
        )
      this.TrackerYFilter();
      this.getAllTracker();


    }
    else if (this.field.frontendLabel == 'Project') {
      this.field.eavAttributeOption = [];
      this.projectsService.getAllProjectsDropDown()
        .pipe(take(1))
        .subscribe(
          data => {
            this.projectsList = data;
            this.projectsTypeList = data;
            this.filteredProjectsTypeList = this.projectsTypeList;
          },
          error => {
          }
        )
      this.getAllProjects();
      this.ProjectsYFilter();



    }


    else if (this.field.frontendLabel == 'Doctors') {
      this.field.eavAttributeOption = [];
      this.doctorService.getAllDoctorDropDown(3)
        .pipe(take(1))
        .subscribe(
          data => {
            this.doctorList = data;
            this.doctorTypeList = data;
            this.filteredDoctorTypeList = this.doctorTypeList;
          },
          error => {
          }
        )
      this.DoctorYFilter();
      this.getAllDoctor();


    }

    else if (this.field.frontendLabel == 'Form') {
      this.field.eavAttributeOption = [];
      this.dynamicFormGroupService.getAllDynmaicFormDropDown(1)
        .pipe(take(1))
        .subscribe(
          (res) => {
            this.dynamicFormList = res;
            this.dynamicFormTypeList = this.dynamicFormList;
            this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
          },
          (error) => { }
        );
      this.DoctorYFilter();
      this.getAllDoctor();


    }
    else if (this.field.frontendLabel == 'Tags') {
      this.field.eavAttributeOption = [];
      this.tagesStatusService.getAllTagsDropDown(5)
        .pipe(take(1))
        .subscribe(
          data => {
            this.tagsList = data;
            this.tagsTypeList = data;
            this.filteredtagsTypeList = this.tagsTypeList;
          },
          error => {
          }
        )
      this.getAllTags();
      this.TagsYFilter();


    }
    else if (this.field.frontendLabel == 'Industry Type') {
      this.field.eavAttributeOption = [];
      this.industryTypeService.getAllIndustryTypeDropDown(6)
        .pipe(take(1))
        .subscribe(
          data => {
            this.industryList = data;
            this.industryTypeList = data;
            this.filteredindustryTypeList = this.industryTypeList;
          },
          error => {
          }
        )
      this.getAllIndustry();
      this.IndustryYFilter();


    }
    else if (this.field.frontendLabel == 'Business Type') {
      this.field.eavAttributeOption = [];
      this.bussinessTypeService.getAllBusinessDropDown(7)
        .pipe(take(1))
        .subscribe(
          data => {
            this.BusinessList = data;
            this.BusinessTypeList = data;
            this.filteredBusinessTypeList = this.BusinessTypeList;
          },
          error => {
          }
        )
      this.getAllBusiness();
      this.BusinessYFilter();


    }
    else if (this.field.frontendLabel == 'Category') {
      this.field.eavAttributeOption = [];
      this.categoryYFilter();
      this.getCategoryList();
    }

    // else if (this.field.frontendLabel == 'Product') {
    //   this.field.eavAttributeOption = [];


    // }

    else if (this.field.frontendLabel == 'Vendor') {

      let val: any | null = null;

      const encryptedUserSettings = localStorage.getItem('userSettingsData');

      if (encryptedUserSettings) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
          const userSettings = JSON.parse(decrypted);
          val = userSettings.userType;
        } catch (error) {
        }
      }

      if (!val) {
        const encryptedSigninDetails = localStorage.getItem('signinDetails');
        if (encryptedSigninDetails) {
          try {
            const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
            const signinDetails = JSON.parse(decrypted);
            val = signinDetails.userType;
          } catch (error) {
            console.error('Error decrypting or parsing signinDetails:', error);
          }
        }
      }


      if (val > 0) {

        this.group.value[this.field.attributeCode] = val;
        this.group.patchValue(this.group.value)
        this.supDisabled = true;
      }

      this.supplierService.getAllVendorDropDown(1)
        .pipe(take(1))
        .subscribe(
          data => {
            this.supplierList = data;

            let object = {
              "id": 0,
              "name": "Default",
              "company": "Default",
              "vatNo": "1992993",
              "gstNo": "31",
              "email": "yeshwanth@calsoftgroup.com",
              "phone": "123",
              "address": "safas",
              "city": "123",
              "state": "safas",
              "postalCode": "1223",
              "country": "Afghanistan",
              "cf1": null,
              "cf2": null,
              "cf3": null,
              "cf4": null,
              "cf5": null,
              "cf6": null,
              "payment_term": 0,
              "logo": "drop-shipping.png",
              "awardPoints": 0,
              "deposit_amount": 0.0,
              "supplierWebsite": "test.com",
              "supplierLatitude": "sasf",
              "supplierLongitude": "12",
              "operationType": null
            }
            this.supplierList.push(object);
            this.supplierTypeList = data;
            this.filteredsupplierTypeList = this.supplierTypeList;

          }
        )

      this.supplierYFilter();
      this.getAllsupplier();
    }

    this.value = this.field.eavAttributeOption;
    this.fieldTypeList = this.value;

    if (this.field.frontendLabel == 'Stage') {

      const reasonForLossIndex = this.eavEntityAttribute?.findIndex(attr =>
        attr.eavAttribute && attr.eavAttribute.attributeCode === 'ReasonForLoss'
      );

      if (reasonForLossIndex != undefined) {

        if (reasonForLossIndex !== -1) {

          this.reasonForLostList = this.eavEntityAttribute[reasonForLossIndex]['eavAttribute']['eavAttributeOption'];

          this.initializeStageMonitoring();

        } else {
        }
      }

    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['group'] && this.group && this.field) {

      if (this.field.frontendLabel === 'Stage') {

        this.cdr.detectChanges();

        setTimeout(() => {
          const currentStageValue = this.group.get(this.field.attributeCode)?.value;
          if (currentStageValue && this.reasonForLostList) {
            this.checkStageValueForLoss(currentStageValue);
          }
        }, 100);
      }
    }

    if (changes['field'] && this.field && this.field.frontendLabel === 'Stage') {
      setTimeout(() => {
        this.initializeStageMonitoring();
      }, 100);
    }
  }

  private initializeStageMonitoring(): void {
    if (!this.group || !this.field || this.field.frontendLabel !== 'Stage') {
      return;
    }

    this.group.get(this.field.attributeCode)?.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(value => {
        this.checkStageValueForLoss(value);
      });


    const currentValue = this.group.get(this.field.attributeCode)?.value;
    if (currentValue) {
      this.checkStageValueForLoss(currentValue);
    }
  }


  setCategory(event: any, selectedOption: any) {
    if (event && event.isUserInput !== false) {
      const categoryId = (typeof selectedOption === 'object' && selectedOption) ? (selectedOption.id || selectedOption.categoryId) : selectedOption;
      this.setCategoryNew(categoryId);
    }
  }

  setCategoryNew(event: any) {
    if (event != null && event !== undefined && event !== '') {
      let catId = (typeof event === 'object' && (event.id || event.categoryId)) ? (event.id || event.categoryId) : event;
      this.searchTermValue = "categoryId:" + catId;
      this.getProduct(this.searchTermValue);
    } else {
      this.getProduct('');
    }
  }


  //category

  CategoryTypeList: any;
  filteredCategoryTypeList: any = [];
  CategoryList: any;
  public categoryFilterControl: UntypedFormControl = new UntypedFormControl();

  getCategoryList() {
    this.categoriesService.getAllCategories(0, 1000, 'id,desc')
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          const cats = res['content'] || res || [];
          this.CategoryList = cats;
          this.CategoryTypeList = cats;
          this.filteredCategoryTypeList = cats;
        },
        (error) => { }
      );
  }

  categoryYFilter() {
    this.categoryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.categoryFilter();
      });
  }

  protected categoryFilter() {
    if (!this.CategoryTypeList) {
      return;
    }
    let search = this.categoryFilterControl.value;
    if (!search) {
      this.filteredCategoryTypeList = this.CategoryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredCategoryTypeList = this.CategoryTypeList.filter(
      (category) => ((category['name'] || category['categoryName']) || '').toLowerCase().indexOf(search) > -1
    );
  }

  getAllCategory() {
    this.filteredCategoryTypeList = this.CategoryTypeList;
  }

  //lecture

  lectureList: any = [];
  lectureTypeList: any = [];
  filteredlectureTypeList: any = [];
  lectureControl: UntypedFormControl = new UntypedFormControl();
  lectureFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllLecture() {
    this.filteredlectureTypeList = this.lectureTypeList;
  }

  LectureYFilter() {
    this.lectureFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.lectureFilter();
      });
  }

  protected lectureFilter() {
    if (!this.lectureTypeList) {
      return;
    }
    // get the search keyword
    let search = this.lectureFilterControl.value;
    if (!search) {
      this.filteredlectureTypeList = this.lectureTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredlectureTypeList = this.filteredlectureTypeList.filter(lecture => lecture['company'].toLowerCase().indexOf(search) > -1)
  }

  // Doctor

  doctorList: any = [];
  doctorTypeList: any = [];
  filteredDoctorTypeList: any = [];
  doctorControl: UntypedFormControl = new UntypedFormControl();
  doctorFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllDoctor() {
    this.filteredDoctorTypeList = this.doctorTypeList;
  }

  DoctorYFilter() {
    this.doctorFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.doctorFilter();
      });
  }

  protected doctorFilter() {
    if (!this.doctorTypeList) {
      return;
    }
    // get the search keyword
    let search = this.doctorFilterControl.value;
    if (!search) {
      this.filteredDoctorTypeList = this.doctorTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredDoctorTypeList = this.filteredDoctorTypeList.filter(doctor => doctor['company'].toLowerCase().indexOf(search) > -1)
  }


  isMultiTagField(field: any): boolean {
    if (!field) return false;
    const label = (field.frontendLabel || '').toLowerCase();
    const code = (field.attributeCode || '').toLowerCase();
    return code === 'tagname' || code === 'tagnames' || label === 'tag name';
  }

  isSingleTagField(field: any): boolean {
    if (!field) return false;
    const label = (field.frontendLabel || '').toLowerCase();
    const code = (field.attributeCode || '').toLowerCase();
    return code === 'tags' || code === 'tagid' || code === 'tagids' || (label === 'tags' && code !== 'tagname');
  }

  isTagField(field: any): boolean {
    return this.isMultiTagField(field) || this.isSingleTagField(field);
  }

  //Tags

  tagsList: any = [];
  tagsTypeList: any = [];
  filteredtagsTypeList: any = [];
  tagsControl: UntypedFormControl = new UntypedFormControl();
  tagsFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllTags() {
    this.tagesStatusService.getAllTagsDropDown(5).subscribe(
      data => {
        this.tagsList = data || [];
        this.tagsTypeList = data || [];
        this.filteredtagsTypeList = this.tagsTypeList;
        this.patchTagValue();
      },
      error => { }
    );
  }

  TagsYFilter() {
    this.tagsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagsFilter();
      });
  }

  protected tagsFilter() {
    if (!this.tagsTypeList) {
      return;
    }
    let search = this.tagsFilterControl.value;
    if (!search) {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredtagsTypeList = this.tagsTypeList.filter(tags => (tags['statusName'] || '').toLowerCase().indexOf(search) > -1);
  }


  //Industry Type

  industryList: any = [];
  industryTypeList: any = [];
  filteredindustryTypeList: any = [];
  industryFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllIndustry() {
    this.filteredindustryTypeList = this.industryTypeList;
  }

  IndustryYFilter() {
    this.industryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.industryFilter();
      });
  }

  protected industryFilter() {
    if (!this.industryTypeList) {
      return;
    }
    // get the search keyword
    let search = this.industryFilterControl.value;
    if (!search) {
      this.filteredindustryTypeList = this.industryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredindustryTypeList = this.filteredindustryTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
  }


  //Business Type

  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];
  BusinessFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllBusiness() {
    this.filteredBusinessTypeList = this.BusinessTypeList;
  }

  BusinessYFilter() {
    this.BusinessFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.BusinessFilter();
      });
  }

  protected BusinessFilter() {
    if (!this.BusinessTypeList) {
      return;
    }
    // get the search keyword
    let search = this.BusinessFilterControl.value;
    if (!search) {
      this.filteredBusinessTypeList = this.BusinessTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredBusinessTypeList = this.filteredBusinessTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
  }

  filterCountry(value: any): string[] {
    var filterValue: any;
    if (value != '' && typeof value == 'string') {
      filterValue = value.toLowerCase();
    } else if (typeof value == "object") {
      if (value['countryId'] != undefined) {
        filterValue = value['countryName'];
        this.firstFormGroup.patchValue({ countryId: value['countryId'], countryName: value['countryName'] });
        filterValue = filterValue.toLowerCase();
      }
    } else {
      filterValue = "";
    }
    return this.countryTypeList.filter(option => option.countryName.toLowerCase().includes(filterValue));
  }

  private _filter(value: any): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  getAllCountry() {
    this.filteredcountryTypeList = this.countryTypeList;
  }
  countrYFilter() {
    this.countryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.countryFilter();
      });
  }

  protected countryFilter() {
    if (!this.countryTypeList) {
      return;
    }

    // get the search keyword
    let search = this.countryFilterControl.value;
    if (!search) {
      this.filteredcountryTypeList = this.countryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredcountryTypeList = this.countryTypeList.filter(country => country['countryName'].toLowerCase().indexOf(search) > -1)
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }


  fieldControl: UntypedFormControl = new UntypedFormControl();
  fieldFilterControl: UntypedFormControl = new UntypedFormControl();

  filterField(value: any): string[] {
    var filterValue: any;
    if (value != '' && typeof value == 'string') {
      filterValue = value.toLowerCase();
    } else if (typeof value == "object") {
      if (value['optionId'] != undefined) {
        filterValue = value['optionId'];
        this.firstFormGroup.patchValue({ optionId: value['optionId'], field: value['optionId'] });
        filterValue = filterValue.toLowerCase();
      }
    } else {
      filterValue = "";
    }
    return this.fieldTypeList.filter(option =>

      option.eavAttributeOptionValue[0].value.toLowerCase().includes(filterValue));
  }

  getAllField() {
    this.fieldTypeList = this.value;
  }
  fielDFilter() {
    this.fieldFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.fieldFilter();
      });
  }

  protected fieldFilter() {
    if (!this.fieldTypeList) {
      return;
    }
    let search = this.fieldFilterControl.value;
    if (!search) {
      this.fieldTypeList = this.value.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.fieldTypeList = this.value.filter(field => field.eavAttributeOptionValue[0].value.toLowerCase().indexOf(search) > -1)
  }

  //////matselect tax class

  filterTaxclass(value: any): string[] {
    var filterValue: any;
    if (value != '' && typeof value == 'string') {
      filterValue = value.toLowerCase();
    } else if (typeof value == "object") {
      if (value['classId'] != undefined) {
        filterValue = value['className'];
        this.firstFormGroup.patchValue({ classId: value['classId'], className: value['className'] });
        filterValue = filterValue.toLowerCase();
      }
    } else {
      filterValue = "";
    }
    return this.taxClassTypeList.filter(option => option.className.toLowerCase().includes(filterValue));
  }


  // private _filter(value: any): string[] {
  //   const filterValue = value.toLowerCase();

  //   return this.options.filter(option => option.toLowerCase().includes(filterValue));
  // }

  getAllTaxclass() {
    this.filteredTaxClassList = this.taxClassTypeList;
  }
  taxclassYFilter() {
    this.taxclassFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.taxclassFilter();
      });
  }

  protected taxclassFilter() {
    if (!this.taxClassTypeList) {
      return;
    }

    // get the search keyword
    let search = this.taxclassFilterControl.value;
    if (!search) {
      this.filteredTaxClassList = this.taxClassTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredTaxClassList = this.taxClassTypeList.filter(country => country['className'].toLowerCase().indexOf(search) > -1)
  }
  //Pincode

  getAllPicodeBased() {
    this.filteredPicodeBasedList = this.pincodeBasedTypeList;
  }

  PicodeBasedYFilter() {
    this.pincodeBasedFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.PicodeBasedFilter();
      });
  }

  protected PicodeBasedFilter() {
    if (!this.pincodeBasedTypeList) {
      return;
    }

    // get the search keyword
    let search = this.pincodeBasedFilterControl.value;
    if (!search) {
      this.filteredPicodeBasedList = this.pincodeBasedTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredPicodeBasedList = this.pincodeBasedTypeList.filter(country => country['groupName'].toLowerCase().indexOf(search) > -1)
  }


  booleanField: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]

  ///supplier

  //country
  supplierList: any = [];
  supplierTypeList: any = [];
  filteredsupplierTypeList: any = [];
  supplierControl: UntypedFormControl = new UntypedFormControl();
  supplierFilterControl: UntypedFormControl = new UntypedFormControl();
  options: any;



  getAllsupplier() {
    this.filteredsupplierTypeList = this.supplierTypeList;
  }

  supplierYFilter() {
    this.supplierFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.supplierFilter();
      });
  }

  protected supplierFilter() {
    if (!this.supplierTypeList) {
      return;
    }
    // get the search keyword
    let search = this.supplierFilterControl.value;
    if (!search) {
      this.filteredsupplierTypeList = this.supplierTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredsupplierTypeList = this.supplierTypeList.filter(supplier => supplier['company'].toLowerCase().indexOf(search) > -1)
  }




  //lead Source

  leadSourceList: any;
  leadSourceTypeList: any;
  filteredleadSourceTypeList: any;

  public leadSourceFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadSourceList() {

    this.filteredleadSourceTypeList = this.leadSourceTypeList;
  }

  LeadSourceYFilter() {
    this.leadSourceFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadSourceFilter();
      });
  }


  protected LeadSourceFilter() {
    if (!this.leadSourceTypeList) {
      return;
    }
    // get the search keyword
    let search = this.leadSourceFilterControl.value;
    if (!search) {
      this.filteredleadSourceTypeList = this.leadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredleadSourceTypeList = this.leadSourceTypeList.filter(source => source['sourceName']
      .toLowerCase().indexOf(search) > -1)
  }


  //lead status

  leadStatusList: any;
  leadStatusTypeList: any;
  filteredleadStatusTypeList: any;

  public leadStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadStatusList() {

    this.filteredleadStatusTypeList = this.leadStatusTypeList;
  }

  LeadStatusYFilter() {
    this.leadStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.leadStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.leadStatusFilterControl.value;
    if (!search) {
      this.filteredleadStatusTypeList = this.leadStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredleadStatusTypeList = this.leadStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }


  //project stage

  projectStageList: any;
  projectStageTypeList: any;
  filteredprojectStageTypeList: any;

  public projectStageFilterControl: UntypedFormControl = new UntypedFormControl();

  getProjectStageList() {

    this.filteredprojectStageTypeList = this.projectStageTypeList;
  }

  ProjectStageYFilter() {
    this.projectStageFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.ProjectStageFilter();
      });
  }


  protected ProjectStageFilter() {
    if (!this.projectStageTypeList) {
      return;
    }
    // get the search keyword
    let search = this.projectStageFilterControl.value;
    if (!search) {
      this.filteredprojectStageTypeList = this.projectStageTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredprojectStageTypeList = this.projectStageTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }


  //deals close Reason

  dealsCloseReasonList: any;
  dealsCloseReasonTypeList: any;
  filteredDealsCloseReasonTypeList: any;

  public dealsCloseReasonFilterControl: UntypedFormControl = new UntypedFormControl();

  getDealsCloseReasonList() {

    this.filteredDealsCloseReasonTypeList = this.dealsCloseReasonTypeList;
  }

  DealsCloseReasonYFilter() {
    this.dealsCloseReasonFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.DealsCloseReasonFilter();
      });
  }


  protected DealsCloseReasonFilter() {
    if (!this.dealsCloseReasonTypeList) {
      return;
    }
    // get the search keyword
    let search = this.dealsCloseReasonFilterControl.value;
    if (!search) {
      this.filteredDealsCloseReasonTypeList = this.dealsCloseReasonTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredDealsCloseReasonTypeList = this.dealsCloseReasonTypeList.filter(reason => reason['statusName']
      .toLowerCase().indexOf(search) > -1)
  }


  //owner name

  userList: any;
  userTypeList: any;
  filtereduserTypeList: any;

  public userOwnerFilterControl: UntypedFormControl = new UntypedFormControl();

  getOwnerList() {

    this.filtereduserTypeList = this.userTypeList;
  }

  LeadOwnerYFilter() {
    this.userOwnerFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeaduserOwnerFilter();
      });
  }


  protected LeaduserOwnerFilter() {
    if (!this.userTypeList) {
      return;
    }
    // get the search keyword
    let search = this.userOwnerFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }



  //distributor

  distributorList: any;
  distributorTypeList: any;
  filteredDistributorTypeList: any;

  public userdistributorFilterControl: UntypedFormControl = new UntypedFormControl();

  getdistributorList() {

    this.filteredDistributorTypeList = this.distributorTypeList;
  }

  DistributorYFilter() {
    this.userdistributorFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.DistributorFilter();
      });
  }


  protected DistributorFilter() {
    if (!this.distributorTypeList) {
      return;
    }
    let search = this.userdistributorFilterControl.value;
    if (!search) {
      this.filteredDistributorTypeList = this.distributorTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredDistributorTypeList = this.distributorTypeList.filter(user => user['distributorName'].toLowerCase().indexOf(search) > -1)
  }




  //Page
  public cmsFilterControl: UntypedFormControl = new UntypedFormControl();

  cmsList: any;
  cmsTypeList: any;
  filteredCmsTypeList: any;

  getCmsList() {
    this.filteredCmsTypeList = this.cmsTypeList;
  }

  CmsYFilter() {
    this.cmsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.CmsFilter();
      });
  }


  protected CmsFilter() {
    if (!this.cmsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.cmsFilterControl.value;
    if (!search) {
      this.filteredCmsTypeList = this.cmsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredCmsTypeList = this.cmsTypeList.filter(cms => cms['title']
      .toLowerCase().indexOf(search) > -1)
  }

  getAllCmsSet() {
    this.filteredCmsTypeList = this.cmsTypeList;
  }
  priceControl = new FormControl(0.0);

  public page: any = Constant.PAGE;
  public size: any = 1000;


  sortParam: any = 'entityId' + "," + Constant.Dsc;
  productList: any = [];
  getProduct(searchTerm: any) {
    this.spinner = true;
    let search = '';
    if (searchTerm != null && searchTerm !== undefined && searchTerm !== '') {
      const termStr = ('' + searchTerm).trim();
      if (termStr.includes('categoryId:')) {
        search = termStr;
      } else if (!isNaN(Number(termStr)) && Number(termStr) > 0) {
        search = "categoryId:" + termStr;
      } else {
        search = "name:*" + termStr + "* OR code:*" + termStr + "*";
      }
    }
    this.productService.getProductByType(0, 50, 'id,desc', search)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          this.spinner = false;
          this.productList = res['content'] || res || [];

          this.setPrice();
        },
        error => {
          this.spinner = false;
        }
      );
  }

  setPrice() {
    if (this.productList && this.productList.length > 0 && this.group) {
      const val = this.group.get('Product')?.value || this.group.get('ProductName')?.value || this.group.get('ProductId')?.value;
      if (val != null && val !== '') {
        const index = this.productList.findIndex(x =>
          (x.id != null && x.id == val) ||
          (x.productId != null && x.productId == val) ||
          (x.entityId != null && x.entityId == val) ||
          (x.name != null && x.name === val)
        );
        if (index > -1) {
          const price = this.productList[index].price ?? 0;
          this.priceControl.setValue(price);
        }
      }
    }
  }

  setPriceSelection(event: any, productId: any) {
    if (event && event.isUserInput !== false) {
      if (this.productList && this.productList.length > 0) {
        const index = this.productList.findIndex(x =>
          (x.id != null && x.id == productId) ||
          (x.productId != null && x.productId == productId) ||
          (x.entityId != null && x.entityId == productId) ||
          (x.name != null && x.name === productId)
        );
        if (index > -1) {
          const price = this.productList[index].price ?? 0;
          this.priceControl.setValue(price);
        }
      }
    }
  }


  //

  createDynamicForm(event, formGroupId) {
    if (event.isUserInput != false) {

      this.getcreateDynamicForm(formGroupId)
    }

  }

  getcreateDynamicForm(formGroupId) {

    this.getFormArray(formGroupId)

  }

  init: boolean = false;


  regConfig: any[] = [];

  getFormArray(formGroupId) {
    this.init = false;
    this.dynamicFormLabelService.getDynmaicForm(formGroupId)
      .pipe(take(1))
      .subscribe((data) => {


        let value: any = data

        if (value.length > 0) {
          this.regConfig = value;
          this.init = true;
          this.newType = 2;
        }


        this.cdr.detectChanges();

      });
  }

  onFormSubmitted(event) {

    if (this.router.url.includes('/deals')) {
      delete event['Stage'];
    } else {
      delete event['LeadStatus'];
    }

    const firstValue = Object.values(event)[0];

    if (firstValue !== undefined && firstValue != null) {
      const secondaryLeadStatusControl = this.group.get('SecondaryLeadStatus');

      if (secondaryLeadStatusControl) {
        secondaryLeadStatusControl.setValue(firstValue);
      }
    }


    if (this.router.url.includes('/deals')) {
      event['Stage'] = this.group.value.Stage;
    } else {
      event['LeadStatus'] = this.group.value.LeadStatus;
    }


    for (const key in event) {
      if (event.hasOwnProperty(key) && this.group.get(key)) {
        if (event[key] != null) {

          this.group.get(key).setValue(event[key]);
        }
      }

    }



  }


  onStageSelectionChange(event: any, statusName: string) {
    if (event.isUserInput) {
      this.showReasonForLoss = statusName && statusName.toLowerCase().includes('lost');
      if (!this.showReasonForLoss && this.group.get('ReasonForLoss')) {
        this.group.get('ReasonForLoss').setValue(null);
      }
    }
  }

  checkInitialStageValue() {

    const currentStageId = this.group.get(this.field.attributeCode)?.value;

    if (currentStageId && this.filteredleadStatusTypeList) {

      const currentStage = this.filteredleadStatusTypeList.find(stage => stage.statusId == currentStageId);

      if (currentStage && currentStage.statusName) {

        this.showReasonForLoss = currentStage.statusName.toLowerCase().includes('lost');

      }
    }
  }

  checkStageValueForLoss(stageId: any) {

    if (!stageId) {
      this.showReasonForLoss = false;
      return;
    }

    if (!this.filteredleadStatusTypeList || this.filteredleadStatusTypeList.length === 0) {

      setTimeout(() => {
        this.checkStageValueForLoss(stageId);
      }, 200);
      return;
    }

    const currentStage = this.filteredleadStatusTypeList.find(stage => stage.statusId == stageId);

    if (currentStage && currentStage.statusName) {

      const isLostStage = currentStage.statusName.toLowerCase().includes('lost');
      this.showReasonForLoss = isLostStage;


      if (!this.showReasonForLoss && this.group.get('ReasonForLoss')) {
        this.group.get('ReasonForLoss').setValue(null);
      } else {

        let formId = currentStage.dynamicFormGroupId;

        this.getcreateDynamicForm(currentStage.dynamicFormGroupId)
      }
    } else {
      this.showReasonForLoss = false;
    }
  }

  //contact form

  dynamicFormTypeList: any;
  filtereddynamicFormTypeList: any;

  public dynamicFormFilterControl: UntypedFormControl = new UntypedFormControl();

  dynamicFormList: any;
  getdynamicFormList() {
    this.dynamicFormGroupService.getAllDynmaicFormDropDown(1)
      .pipe(take(1))
      .subscribe(
        (res) => {
          this.dynamicFormList = res;
          this.dynamicFormTypeList = this.dynamicFormList;
          this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
        },
        (error) => { }
      );
  }

  dynmaicFormYFilter() {
    this.dynamicFormFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.dynamicFilter();
      });
  }

  protected dynamicFilter() {
    if (!this.dynamicFormTypeList) {
      return;
    }
    let search = this.dynamicFormFilterControl.value;
    if (!search) {
      this.filtereddynamicFormTypeList = this.dynamicFormTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filtereddynamicFormTypeList = this.dynamicFormTypeList.filter(
      (dynamicForm) => dynamicForm['name'].toLowerCase().indexOf(search) > -1
    );
  }

  getAlldynamicForm() {
    this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
  }


  // Tracker

  trackerList: any = [];
  trackerTypeList: any = [];
  filteredTrackerTypeList: any = [];
  trackerControl: UntypedFormControl = new UntypedFormControl();
  trackerFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTracker() {
    this.filteredTrackerTypeList = this.trackerTypeList;
  }

  TrackerYFilter() {
    this.trackerFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.trackerFilter();
      });
  }

  protected trackerFilter() {
    if (!this.trackerTypeList) {
      return;
    }
    // get the search keyword
    let search = this.trackerFilterControl.value;
    if (!search) {
      this.filteredTrackerTypeList = this.trackerTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredTrackerTypeList = this.filteredTrackerTypeList.filter(tracker => tracker['trackerName'].toLowerCase().indexOf(search) > -1)
  }

  //projects

  projectsList: any = [];
  projectsTypeList: any = [];
  filteredProjectsTypeList: any = [];
  projectsControl: UntypedFormControl = new UntypedFormControl();
  projectsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllProjects() {
    this.filteredProjectsTypeList = this.projectsTypeList;
  }

  ProjectsYFilter() {
    this.projectsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.projectsFilter();
      });
  }

  protected projectsFilter() {
    if (!this.projectsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.projectsFilterControl.value;
    if (!search) {
      this.filteredProjectsTypeList = this.projectsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredProjectsTypeList = this.filteredProjectsTypeList.filter(projects => projects['name'].toLowerCase().indexOf(search) > -1)
  }

  // Priority

  priorityList: any = [];
  priorityTypeList: any = [];
  filteredPriorityTypeList: any = [];
  priorityControl: UntypedFormControl = new UntypedFormControl();
  PriorityFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllPriority() {
    this.filteredPriorityTypeList = this.priorityTypeList;
  }

  PriorityYFilter() {
    this.PriorityFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.priorityFilter();
      });
  }

  protected priorityFilter() {
    if (!this.priorityTypeList) {
      return;
    }
    // get the search keyword
    let search = this.PriorityFilterControl.value;
    if (!search) {
      this.filteredPriorityTypeList = this.priorityTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredPriorityTypeList = this.filteredPriorityTypeList.filter(priority => priority['priorityName'].toLowerCase().indexOf(search) > -1)
  }

  isOptionSelected: boolean = false;

  patchTagValue() {
    if (!this.group || !this.field) return;
    const ctrlName = this.field.attributeCode;
    const control = this.group.get(ctrlName);
    if (!control) return;

    let val = control.value;
    if (val === undefined || val === null || val === '') return;

    if (this.isMultiTagField(this.field)) {
      // Patch multi-select array for tagName / tagNames
      let valArray: string[] = [];
      if (typeof val === 'string' && val.trim().length > 0) {
        let splitVals = val.split(',').map(s => s.trim()).filter(s => s.length > 0);
        splitVals.forEach(v => {
          let numVal = parseInt(v, 10);
          if (!isNaN(numVal)) {
            let foundTag = (this.tagsList || []).find(t => t.statusId == numVal);
            if (foundTag && !valArray.includes(foundTag.statusName)) {
              valArray.push(foundTag.statusName);
            }
          } else {
            if (!valArray.includes(v)) {
              valArray.push(v);
            }
          }
        });
      } else if (typeof val === 'number') {
        let foundTag = (this.tagsList || []).find(t => t.statusId == val);
        if (foundTag && !valArray.includes(foundTag.statusName)) {
          valArray.push(foundTag.statusName);
        }
      } else if (Array.isArray(val)) {
        valArray = val;
      }

      if (valArray.length > 0) {
        control.setValue(valArray, { emitEvent: false });
      }
    } else if (this.isSingleTagField(this.field)) {
      // Single value patch ONLY for Tags / TagId (integer / single ID)
      if (typeof val === 'string' && val.includes(',')) {
        let firstVal = val.split(',')[0].trim();
        let numVal = parseInt(firstVal, 10);
        control.setValue(!isNaN(numVal) ? numVal : firstVal, { emitEvent: false });
      } else if (typeof val === 'string' && !isNaN(parseInt(val, 10))) {
        control.setValue(parseInt(val, 10), { emitEvent: false });
      }
    }
  }

  onTagsSelectedSingle(event, option) {
    if (event && event.isUserInput != false && option) {
      this.isOptionSelected = true;
      if (this.group.get('TagId')) {
        this.group.get('TagId').setValue(option.statusId);
      }
      if (this.group.get('TagName')) {
        this.group.get('TagName').setValue(option.statusName);
      }
      if (this.group.get('tagName')) {
        this.group.get('tagName').setValue(option.statusName);
      }
      if (this.group.get('tagNames')) {
        this.group.get('tagNames').setValue(option.statusName);
      }
      if (this.group.get('tagIds')) {
        this.group.get('tagIds').setValue(String(option.statusId));
      }
      if (this.group.get('Tags')) {
        this.group.get('Tags').setValue(option.statusId);
      }
    }
  }

  onTagsSelectedMulti(event) {
    if (!this.group || !this.field) return;
    const ctrlName = this.field.attributeCode;
    const control = this.group.get(ctrlName);
    let selectedVal = control?.value;
    let selectedNames: string[] = Array.isArray(selectedVal) ? selectedVal : (selectedVal ? [selectedVal] : []);
    let selectedTags = (this.tagsList || []).filter(t => selectedNames.includes(t.statusName));
    let tagIdsStr = selectedTags.map(t => t.statusId).join(',');
    let tagNamesStr = selectedNames.join(',');
    let firstTagId = selectedTags.length > 0 ? selectedTags[0].statusId : null;

    if (ctrlName !== 'TagId' && this.group.get('TagId')) {
      this.group.get('TagId').setValue(firstTagId, { emitEvent: false });
    }
    if (ctrlName !== 'TagName' && this.group.get('TagName')) {
      this.group.get('TagName').setValue(tagNamesStr, { emitEvent: false });
    }
    if (ctrlName !== 'tagName' && this.group.get('tagName')) {
      this.group.get('tagName').setValue(tagNamesStr, { emitEvent: false });
    }
    if (ctrlName !== 'tagNames' && this.group.get('tagNames')) {
      this.group.get('tagNames').setValue(tagNamesStr, { emitEvent: false });
    }
    if (ctrlName !== 'tagIds' && this.group.get('tagIds')) {
      this.group.get('tagIds').setValue(tagIdsStr, { emitEvent: false });
    }
    if (ctrlName !== 'Tags' && this.group.get('Tags')) {
      this.group.get('Tags').setValue(firstTagId, { emitEvent: false });
    }
  }


  setMetalPrice(event, rate) {
    if (event.isUserInput != false) {

      this.updatePrice(rate);
    }
  }

  updatePrice(rate) {
    let weight = this.group.value.weight;
    if (weight > 0) {
      let price = weight * rate;
      this.group.get('price').setValue(price);
      this.group.get('MetalPrice').setValue(price);
    }
  }
  @ViewChild('singleSelect') singleSelect!: MatSelect;

  onOpenedChange(opened: boolean) {
    if (opened) {

      setTimeout(() => {

        this.singleSelect?.panel?.nativeElement; // ensures it's rendered
        (this.singleSelect as any)._overlayDir?.overlayRef?.updatePosition();
      }, 300);
    }
  }

  //lead Source

  productNewList: any;
  productNewTypeList: any;
  filteredproductNewTypeList: any;

  public productNewFilterControl: UntypedFormControl = new UntypedFormControl();

  getproductNewList() {

    this.filteredproductNewTypeList = this.productNewTypeList;
  }

  productNewYFilter() {
    this.productNewFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.productNewFilter();
      });
  }


  protected productNewFilter() {
    if (!this.productNewTypeList) {
      return;
    }
    // get the search keyword
    let search = this.productNewFilterControl.value;
    if (!search) {
      this.filteredproductNewTypeList = this.productNewTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredproductNewTypeList = this.productNewTypeList.filter(source => source['name']
      .toLowerCase().indexOf(search) > -1)
  }

  setOwner(event, object) {
    if (event.isUserInput != false) {

      this.group.get('OwnerId').setValue(object.entityId);
      this.group.get('OwnerName').setValue(object.email);
      this.group.get('Owner').setValue(object.email);

    }
  }

  //zone

  filteredStatus: any[] = [];

  filterCtrl: UntypedFormControl = new UntypedFormControl();

  filterStatus(): void {
    const search = this.filterCtrl.value ? this.filterCtrl.value.toLowerCase() : '';

    this.filteredStatus = this.zone.filter(item =>
      item.value.toLowerCase().includes(search) ||
      item.label.toLowerCase().includes(search)
    );
  }

  zone: TimezoneOption[] = TIMEZONE_ZONES;

  // kept for reference — DO NOT use inline array below; use TIMEZONE_ZONES instead
  private _zone_unused: any = [

    {
      "value": "IST",
      "label": "IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
    },
    {
      "value": "Dateline Standard Time",
      "label": "BIT - (GMT-12:00) International Date Line West"
    },
    {
      "value": "Samoa Standard Time",
      "label": "SMST - (GMT-11:00) Midway Island, Samoa"
    },
    {
      "value": "Hawaiian Standard Time",
      "label": "HAST - (GMT-10:00) Hawaii"
    },
    {
      "value": "Alaskan Standard Time",
      "label": "AK - (GMT-09:00) Alaska"
    },
    {
      "value": "Pacific Standard Time",
      "label": "PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana"
    },
    {
      "value": "US Mountain Standard Time",
      "label": "MST - (GMT-07:00) Arizona"
    },
    {
      "value": "Mountain Standard Time (Mexico)",
      "label": "MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan"
    },
    {
      "value": "Mountain Standard Time",
      "label": "MT - (GMT-07:00) Mountain Time (US and Canada)"
    },
    {
      "value": "Central Standard Time (Mexico)",
      "label": "CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey"
    },
    {
      "value": "Central Standard Time",
      "label": "CT - (GMT-06:00) Central Time (US and Canada)"
    },
    {
      "value": "Central America Standard Time",
      "label": "CAST - (GMT-06:00) Central America"
    },
    {
      "value": "Canada Central Standard Time",
      "label": "CCST - (GMT-06:00) Saskatchewan"
    },
    {
      "value": "US Eastern Standard Time",
      "label": "EST - (GMT-05:00) Indiana (East)"
    },
    {
      "value": "SA Pacific Standard Time",
      "label": "SAPST - (GMT-05:00) Bogota, Lima, Quito"
    },
    {
      "value": "Eastern Standard Time",
      "label": "ET - (GMT-05:00) Eastern Time (US and Canada)"
    },
    {
      "value": "Central Brazilian Standard Time",
      "label": "CBST - (GMT-04:00) Manaus"
    },
    {
      "value": "SA Western Standard Time",
      "label": "SAWST - (GMT-04:00) Caracas, La Paz"
    },
    {
      "value": "Pacific SA Standard Time",
      "label": "PSAST - (GMT-04:00) Santiago"
    },
    {
      "value": "Atlantic Standard Time",
      "label": "AST - (GMT-04:00) Atlantic Time (Canada)"
    },
    {
      "value": "Newfoundland Standard Time",
      "label": "NST - (GMT-03:30) Newfoundland and Labrador"
    },
    {
      "value": "SA Eastern Standard Time",
      "label": "SAEST - (GMT-03:00) Buenos Aires, Georgetown"
    },
    {
      "value": "Greenland Standard Time",
      "label": "GNST - (GMT-03:00) Greenland"
    },
    {
      "value": "E. South America Standard Time",
      "label": "ESAST - (GMT-03:00) Brasilia"
    },
    {
      "value": "Mid-Atlantic Standard Time",
      "label": "UTC02 - (GMT-02:00) Mid-Atlantic"
    },
    {
      "value": "Cape Verde Standard Time",
      "label": "CVT - (GMT-01:00) Cape Verde Islands"
    },
    {
      "value": "Azores Standard Time",
      "label": "AZOST - (GMT-01:00) Azores"
    },
    {
      "value": "Greenwich Standard Time",
      "label": "GST - (GMT-00:00) Casablanca, Monrovia"
    },
    {
      "value": "GMT Standard Time",
      "label": "GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
    },
    {
      "value": "W. Europe Standard Time",
      "label": "WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
    },
    {
      "value": "W. Central Africa Standard Time",
      "label": "ECT - (GMT+01:00) West Central Africa"
    },
    {
      "value": "Romance Standard Time",
      "label": "RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
      "value": "Central European Standard Time",
      "label": "CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
    },
    {
      "value": "Central Europe Standard Time",
      "label": "CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
    },
    {
      "value": "Namibia Standard Time",
      "label": "NMST - (GMT+02:00) Windhoek"
    },
    {
      "value": "South Africa Standard Time",
      "label": "SAST - (GMT+02:00) Harare, Pretoria"
    },
    {
      "value": "Israel Standard Time",
      "label": "ISST - (GMT+02:00) Jerusalem"
    },
    {
      "value": "GTB Standard Time",
      "label": "GTBST - (GMT+02:00) Athens, Bucharest, Istanbul"
    },
    {
      "value": "FLE Standard Time",
      "label": "EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"
    },
    {
      "value": "Egypt Standard Time",
      "label": "EGST - (GMT+02:00) Cairo"
    },
    {
      "value": "E. Europe Standard Time",
      "label": "EEST - (GMT+02:00) Minsk"
    },
    {
      "value": "Russian Standard Time",
      "label": "MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd"
    },
    {
      "value": "E. Africa Standard Time",
      "label": "EAT - (GMT+03:00) Nairobi"
    },
    {
      "value": "Arabic Standard Time",
      "label": "ARST - (GMT+03:00) Baghdad"
    },
    {
      "value": "Arab Standard Time",
      "label": "ABST - (GMT+03:00) Kuwait, Riyadh"
    },
    {
      "value": "Iran Standard Time",
      "label": "IRST - (GMT+03:30) Tehran"
    },
    {
      "value": "Georgian Standard Time",
      "label": "GET - (GMT+04:00) Tblisi"
    },
    {
      "value": "Azerbaijan Standard Time",
      "label": "AZT - (GMT+04:00) Baku"
    },
    {
      "value": "Caucasus Standard Time",
      "label": "AMT - (GMT+04:00) Yerevan"
    },
    {
      "value": "Arabian Standard Time",
      "label": "ARBST - (GMT+04:00) Abu Dhabi, Muscat"
    },
    {
      "value": "Afghanistan Standard Time",
      "label": "AFT - (GMT+04:30) Kabul"
    },
    {
      "value": "Dateline Standard Time",
      "label": "BIT - (GMT-12:00) International Date Line West"
    },
    {
      "value": "Samoa Standard Time",
      "label": "SMST - (GMT-11:00) Midway Island, Samoa"
    },
    {
      "value": "Hawaiian Standard Time",
      "label": "HAST - (GMT-10:00) Hawaii"
    },
    {
      "value": "Alaskan Standard Time",
      "label": "AK - (GMT-09:00) Alaska"
    },
    {
      "value": "Pacific Standard Time",
      "label": "PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana"
    },
    {
      "value": "US Mountain Standard Time",
      "label": "MST - (GMT-07:00) Arizona"
    },
    {
      "value": "Mountain Standard Time (Mexico)",
      "label": "MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan"
    },
    {
      "value": "Mountain Standard Time",
      "label": "MT - (GMT-07:00) Mountain Time (US and Canada)"
    },
    {
      "value": "Central Standard Time (Mexico)",
      "label": "CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey"
    },
    {
      "value": "Central Standard Time",
      "label": "CT - (GMT-06:00) Central Time (US and Canada)"
    },
    {
      "value": "Central America Standard Time",
      "label": "CAST - (GMT-06:00) Central America"
    },
    {
      "value": "Canada Central Standard Time",
      "label": "CCST - (GMT-06:00) Saskatchewan"
    },
    {
      "value": "US Eastern Standard Time",
      "label": "EST - (GMT-05:00) Indiana (East)"
    },
    {
      "value": "SA Pacific Standard Time",
      "label": "SAPST - (GMT-05:00) Bogota, Lima, Quito"
    },
    {
      "value": "Eastern Standard Time",
      "label": "ET - (GMT-05:00) Eastern Time (US and Canada)"
    },
    {
      "value": "Central Brazilian Standard Time",
      "label": "CBST - (GMT-04:00) Manaus"
    },
    {
      "value": "SA Western Standard Time",
      "label": "SAWST - (GMT-04:00) Caracas, La Paz"
    },
    {
      "value": "Pacific SA Standard Time",
      "label": "PSAST - (GMT-04:00) Santiago"
    },
    {
      "value": "Atlantic Standard Time",
      "label": "AST - (GMT-04:00) Atlantic Time (Canada)"
    },
    {
      "value": "Newfoundland Standard Time",
      "label": "NST - (GMT-03:30) Newfoundland and Labrador"
    },
    {
      "value": "SA Eastern Standard Time",
      "label": "SAEST - (GMT-03:00) Buenos Aires, Georgetown"
    },
    {
      "value": "Greenland Standard Time",
      "label": "GNST - (GMT-03:00) Greenland"
    },
    {
      "value": "E. South America Standard Time",
      "label": "ESAST - (GMT-03:00) Brasilia"
    },
    {
      "value": "Mid-Atlantic Standard Time",
      "label": "UTC02 - (GMT-02:00) Mid-Atlantic"
    },
    {
      "value": "Cape Verde Standard Time",
      "label": "CVT - (GMT-01:00) Cape Verde Islands"
    },
    {
      "value": "Azores Standard Time",
      "label": "AZOST - (GMT-01:00) Azores"
    },
    {
      "value": "Greenwich Standard Time",
      "label": "GST - (GMT-00:00) Casablanca, Monrovia"
    },
    {
      "value": "GMT Standard Time",
      "label": "GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
    },
    {
      "value": "W. Europe Standard Time",
      "label": "WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
    },
    {
      "value": "W. Central Africa Standard Time",
      "label": "ECT - (GMT+01:00) West Central Africa"
    },
    {
      "value": "Romance Standard Time",
      "label": "RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
      "value": "Central European Standard Time",
      "label": "CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
    },
    {
      "value": "Central Europe Standard Time",
      "label": "CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
    },
    {
      "value": "Namibia Standard Time",
      "label": "NMST - (GMT+02:00) Windhoek"
    },
    {
      "value": "South Africa Standard Time",
      "label": "SAST - (GMT+02:00) Harare, Pretoria"
    },
    {
      "value": "Israel Standard Time",
      "label": "ISST - (GMT+02:00) Jerusalem"
    },
    {
      "value": "GTB Standard Time",
      "label": "GTBST - (GMT+02:00) Athens, Bucharest, Istanbul"
    },
    {
      "value": "FLE Standard Time",
      "label": "EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"
    },
    {
      "value": "Egypt Standard Time",
      "label": "EGST - (GMT+02:00) Cairo"
    },
    {
      "value": "E. Europe Standard Time",
      "label": "EEST - (GMT+02:00) Minsk"
    },
    {
      "value": "Russian Standard Time",
      "label": "MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd"
    },
    {
      "value": "E. Africa Standard Time",
      "label": "EAT - (GMT+03:00) Nairobi"
    },
    {
      "value": "Arabic Standard Time",
      "label": "ARST - (GMT+03:00) Baghdad"
    },
    {
      "value": "Arab Standard Time",
      "label": "ABST - (GMT+03:00) Kuwait, Riyadh"
    },
    {
      "value": "Iran Standard Time",
      "label": "IRST - (GMT+03:30) Tehran"
    },
    {
      "value": "Georgian Standard Time",
      "label": "GET - (GMT+04:00) Tblisi"
    },
    {
      "value": "Azerbaijan Standard Time",
      "label": "AZT - (GMT+04:00) Baku"
    },
    {
      "value": "Caucasus Standard Time",
      "label": "AMT - (GMT+04:00) Yerevan"
    },
    {
      "value": "Arabian Standard Time",
      "label": "ARBST - (GMT+04:00) Abu Dhabi, Muscat"
    },
    {
      "value": "Afghanistan Standard Time",
      "label": "AFT - (GMT+04:30) Kabul"
    },
    {
      "value": "West Asia Standard Time",
      "label": "WAST - (GMT+05:00) Islamabad, Karachi, Tashkent"
    }

  ]


  //Sequences


  filteredSequencesdropdownTypeList: any;

  public typeYSequencesFilterControl: UntypedFormControl = new UntypedFormControl();

  sequences = new FormControl('');

  dropdownSequencesTypeList: any;
  sequencesList: any;


  getSequncesDropDownList() {

    this.sequencesService.getAllSequencesDropDown()
      .pipe(take(1))
      .subscribe(
        res => {
          this.sequencesList = res;
          this.dropdownSequencesTypeList = res;
          this.filteredSequencesdropdownTypeList = this.dropdownSequencesTypeList;
        },
        error => {
        })
  }


  typeSequncesYFilter() {
    this.typeYSequencesFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidSequnceYFilter();
      });
  }


  protected typeidSequnceYFilter() {
    if (!this.dropdownSequencesTypeList) {
      return;
    }
    let search = this.typeYSequencesFilterControl.value;
    if (!search) {
      this.filteredSequencesdropdownTypeList = this.dropdownSequencesTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredSequencesdropdownTypeList = this.dropdownSequencesTypeList.filter(sequence => sequence['sequenceName'].toLowerCase().indexOf(search) > -1)
  }

  // Country, State, City Methods for Location API

  /**
   * Load all countries on component init
   */
  loadLocationCountries() {
    this.countryStateCityService.getAllCountries()
      .pipe(take(1))
      .subscribe(
        res => {
          this.locationCountries = res;
          this.filteredLocationCountries = res;
        },
        error => {
          console.error('Error loading countries', error);
        }
      );
  }

  /**
   * Handle country search input
   */
  onLocationCountrySearch() {
    this.countrySearchControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((searchText: string) => {
        if (!searchText) {
          this.filteredLocationCountries = this.locationCountries;
        } else {
          const lowerText = searchText.toLowerCase();
          this.filteredLocationCountries = this.locationCountries.filter(c =>
            c.name?.toLowerCase().includes(lowerText)
          );
        }
      });
  }

  /**
   * Handle country selection change
   */
  onLocationCountryChange(event: any) {
    const selectedCountry = event.value;
    if (selectedCountry) {
      // Find the full country object by name (case-insensitive)
      const countryObj = this.locationCountries.find(c => c.name?.toLowerCase() === selectedCountry?.toLowerCase());
      this.selectedCountryId = countryObj ? (countryObj.id || countryObj) : selectedCountry;

      // Reset state and city
      this.locationStates = [];
      this.locationCities = [];
      this.filteredLocationStates = [];
      this.filteredLocationCities = [];
      this.selectedStateId = null;
      this.selectedCityId = null;

      // Clear state and city form controls
      const stateControl = this.group.get('State');
      const cityControl = this.group.get('City');
      if (stateControl) stateControl.reset();
      if (cityControl) cityControl.reset();

      // Load states for selected country
      this.loadLocationStates(this.selectedCountryId);
    }
  }

  /**
   * Load states for selected country
   */
  loadLocationStates(countryId: any) {
    this.countryStateCityService.getStatesByCountry(countryId)
      .pipe(take(1))
      .subscribe(
        res => {
          this.locationStates = res;
          this.filteredLocationStates = res;
        },
        error => {
          console.error('Error loading states', error);
        }
      );
  }

  /**
   * Handle state search input
   */
  onLocationStateSearch() {
    this.stateSearchControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((searchText: string) => {
        if (!searchText) {
          this.filteredLocationStates = this.locationStates;
        } else {
          const lowerText = searchText.toLowerCase();
          this.filteredLocationStates = this.locationStates.filter(s =>
            s.name?.toLowerCase().includes(lowerText)
          );
        }
      });
  }

  /**
   * Handle state selection change
   */
  onLocationStateChange(event: any) {
    const selectedState = event.value;
    if (selectedState && this.selectedCountryId) {
      // Find the full state object by name (case-insensitive)
      const stateObj = this.locationStates.find(s => s.name?.toLowerCase() === selectedState?.toLowerCase());
      this.selectedStateId = stateObj ? (stateObj.id || stateObj) : selectedState;

      // Reset city
      this.locationCities = [];
      this.filteredLocationCities = [];
      this.selectedCityId = null;

      // Clear city form control
      const cityControl = this.group.get('City');
      if (cityControl) cityControl.reset();

      // Load cities for selected state
      this.loadLocationCities(this.selectedCountryId, this.selectedStateId);
    }
  }

  /**
   * Load cities for selected state
   */
  loadLocationCities(countryId: any, stateId: any) {
    this.countryStateCityService.getCitiesByState(countryId, stateId)
      .pipe(take(1))
      .subscribe(
        res => {
          this.locationCities = res;
          this.filteredLocationCities = res;
        },
        error => {
          console.error('Error loading cities', error);
        }
      );
  }

  /**
   * Handle city search input
   */
  onLocationCitySearch() {
    this.citySearchControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((searchText: string) => {
        if (!searchText) {
          this.filteredLocationCities = this.locationCities;
        } else {
          const lowerText = searchText.toLowerCase();
          this.filteredLocationCities = this.locationCities.filter(c =>
            c.name?.toLowerCase().includes(lowerText)
          );
        }
      });
  }

  /**
   * Handle city selection change
   */
  onLocationCityChange(event: any) {
    const selectedCity = event.value;
    if (selectedCity) {
      // Find the full city object by name (case-insensitive)
      const cityObj = this.locationCities.find(c => c.name?.toLowerCase() === selectedCity?.toLowerCase());
      this.selectedCityId = cityObj ? (cityObj.id || cityObj) : selectedCity;
    }
  }

  /**
   * Load existing location data when editing
   */
  loadExistingLocationData() {
    // Check if Country field has a value
    const countryValue = this.group.get('Country')?.value;

    if (countryValue && this.locationCountries.length > 0) {
      // Find the country object (case-insensitive)
      const countryObj = this.locationCountries.find(c => c.name?.toLowerCase() === countryValue?.toLowerCase());
      if (countryObj) {
        this.selectedCountryId = countryObj.id || countryObj;

        // Load states for this country
        this.countryStateCityService.getStatesByCountry(this.selectedCountryId)
          .pipe(take(1))
          .subscribe(
            res => {
              this.locationStates = res;
              this.filteredLocationStates = res;

              // After states are loaded, check if State field has a value
              const stateValue = this.group.get('State')?.value;

              if (stateValue && this.locationStates.length > 0) {
                // Find the state object (case-insensitive)
                const stateObj = this.locationStates.find(s => s.name?.toLowerCase() === stateValue?.toLowerCase());
                if (stateObj) {
                  this.selectedStateId = stateObj.id || stateObj;
                  // Load cities for this state
                  this.countryStateCityService.getCitiesByState(this.selectedCountryId, this.selectedStateId)
                    .pipe(take(1))
                    .subscribe(
                      citiesRes => {
                        this.locationCities = citiesRes;
                        this.filteredLocationCities = citiesRes;
                      },
                      error => {
                        console.error('Error loading cities for editing', error);
                      }
                    );
                }
              }
            },
            error => {
              console.error('Error loading states for editing', error);
            }
          );
      }
    }
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
